import { render, staticRenderFns } from "./ResetPassword.component.vue?vue&type=template&id=3e50dc14&"
import script from "./ResetPassword.component.vue?vue&type=script&lang=ts&"
export * from "./ResetPassword.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports